<template>
    <div v-loading='loading' align="center" class="booking-confirm notranslate">
        <div v-show="show">
            <el-row style=" margin-top: 30px">
                <span @click="back" class="back-btn"><i class="el-icon el-icon-arrow-left"></i></span>
                <label class="label">{{title}}</label>
            </el-row>

            <div class="list">
                <el-row style="background: #b0bdd3">
                    <label style="font-size: 20px; font-weight: bold; padding: 5px 10px; display: inline-block">{{$t("bookingConfirm.listBooking")}}</label>
                </el-row>
                <el-row v-for="(booking, index) in bookings">
                    <el-button class="btn" @click="next(booking, index)"
                               v-bind:class="{cancel: booking.status === 'CANCEL' || booking.status === 'REFUND' || booking.status === 'FULL_REFUND' || booking.status === 'REFUND_ERROR'}">
                        <p>{{booking.bookingNumber}}</p>
                        <p>{{booking.facilityName}} {{booking.bookingDate}} {{booking.timeRange}}</p>
                        <span v-if='booking.status === "CANCEL" || booking.status === "REFUND" || booking.status === "FULL_REFUND" || booking.status === "REFUND_ERROR"'
                              class="cancel-message">{{$t("bookingConfirm.canceledBooking")}}</span>
                        <span class="next-btn"><i class="el-icon el-icon-arrow-right"></i></span>
                    </el-button>
                </el-row>
                <el-row v-if="bookings.length === 0">
                    <el-button class="btn">
                        現在、予約はありません。
                    </el-button>
                </el-row>
            </div>
            <el-button class="cancel-btn" @click="back">{{$t("bookingConfirm.detail.btn.back")}}</el-button>
        </div>

        <BookingDetail ref="detail" @back="show = true" @canceled="cancel"></BookingDetail>
    </div>
</template>

<script>
    import BookingConfirmApi from "../../api/bookingConfirm/BookingConfirmApi";
    import moment from "moment";
    import BookingDetail from "./BookingDetail";
    import AlertService from "../../service/alert.service";

    require('moment/locale/ja');

    export default {
        name: "BookingConfirm",
        components: {BookingDetail},
        data() {
            return {
                bookings: [],
                show: true,
                loading: false,
                title: this.$t("bookingConfirm.title.bookingConfirm")
            }
        },
        methods: {
            back() {
                this.$router.push({path: "/myPage"})
            },
            next(booking, index) {
                this.show = false;
                this.$refs.detail.load(booking, index);
            },
            cancel(index, isHideDetail) {
                this.bookings.splice(index, 1);
                this.show = isHideDetail;
            }
        },
        mounted() {
            this.loading = true;
            if (this.$route.path.includes("old")) {
                this.title = this.$t("bookingConfirm.title.oldBookingConfirm");

                BookingConfirmApi.getEndUserOldBooking().then(response => {
                    const code = this.$route.query.bookingNumber;
                    let index = -1;
                    this.bookings = response.map((booking, i) => {
                        booking.bookingDate = moment(booking.bookingDate).format("YYYY/MM/DD (dd)");
                        if (booking.bookingNumber == code) index = i;
                        return booking;
                    });
                    this.loading = false;

                    if (code) {
                        if (index !== -1) {
                            this.show = false;
                            this.$refs.detail.load(this.bookings[index], index);
                        } else {
                            AlertService.error("Booking number " + code + " not found")
                        }
                    } else {
                        window.history.pushState({}, "", window.location.pathname);
                    }
                });
            } else {
                this.title = this.$t("bookingConfirm.title.bookingConfirm");
                BookingConfirmApi.getEndUserBooking().then(response => {
                    const code = this.$route.query.bookingNumber;
                    let index = -1;
                    this.bookings = response.map((booking, i) => {
                        booking.bookingDate = moment(booking.bookingDate).format("YYYY/MM/DD (dd)");
                        if (booking.bookingNumber === code) index = i;
                        return booking;
                    });
                    this.loading = false;

                    if (code) {
                        if (index !== -1) {
                            this.show = false;
                            this.$refs.detail.load(this.bookings[index], index);
                        } else {
                            AlertService.error("Booking number " + code + " not found")
                        }
                    } else {
                        window.history.pushState({}, "", window.location.pathname);
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 500px) {
        .back-btn {
            left: 0 !important;
        }
        .list{
            width: 100% !important;
        }
        .label{
            font-size: 28px!important;
        }
    }

    @media screen and (max-width: 1000px) {
        .booking-confirm {
            width: 100%;
        }
        .label {
            font-size: 30px;
            position: relative;
            display: inline-block;
            width: calc(80% - 50px);
            margin: 0 calc(10% + 25px);
        }
        .back-btn {
            left: 10%;
        }
    }

    @media screen and (min-width: 1000px) {
        .booking-confirm {
            width: 80%;
        }

        .cancel-message {
            position: absolute;
            right: 50px;
            margin-right: 60px;
            font-size: 16px;
        }
        .label {
            font-size: 40px;
        }
        .back-btn {
            left: 0;
        }
    }

    .booking-confirm {
        margin: auto;
        position: relative;
    }

    .label {
        font-weight: bold;
    }

    .list {
        width: 80%;
        margin-top: 50px;
        text-align: left;

        .btn {
            width: 100%;
            text-align: left;
            position: relative;
            border-radius: 0;

            &.cancel {
                background: #f3f3f3;
            }

            p {
                width: calc(100% - 40px);
                white-space: normal;
            }
        }
    }

    .next-btn, .back-btn {
        position: absolute;
        cursor: pointer;
        font-size: 40px;
        font-weight: bold;
        z-index: 1;

        &:hover {
            color: #2b3b4e;
        }

        &:active {
            color: #455664;
        }
    }

    .next-btn {
        right: 20px;
        top: calc(50% - 20px);
    }

    .cancel-message {
        color: red;
        right: 50px;
        top: calc(50% - 10px);
        font-weight: bold;
        font-size: 16px;
    }

    .cancel-btn {
        width: 200px;
        margin: 30px auto;
    }

</style>